import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function ProductReveal() {
  const benefits = ['Una página única lista para publicar (con copy en bloques)', 'Un checkout con ruta corta (sin fricción)', '3 mensajes Día 0 listos para enviar (activación, rescate, cierre)', 'Un plan de prueba para saber en 60 minutos si tu embudo está vivo'];
  return <Section className="bg-gradient-to-b from-section to-primary border-y border-white/5" data-id="element-158">
      <div className="text-center mb-12" data-id="element-159">
        <span className="text-accent-blue font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-160">
          Solución Definitiva
        </span>
        <h2 className="text-4xl md:text-6xl font-black text-white mb-6" data-id="element-161">
          Presento: Embudo Exprés
        </h2>
        <p className="text-2xl md:text-3xl text-text-secondary font-light" data-id="element-162">
          Captura Clientes en{' '}
          <span className="text-accent-yellow font-bold" data-id="element-163">24 Horas</span>
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center mt-16" data-id="element-164">
        <div className="order-2 md:order-1 space-y-8" data-id="element-165">
          <p className="text-lg text-text-secondary leading-relaxed" data-id="element-166">
            Un PDF interactivo con plantillas y checklists para montar hoy un
            embudo funcional para tu producto digital de productividad.
          </p>

          <div className="space-y-4" data-id="element-167">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-168">
              Lo que vas a tener al final:
            </h3>
            {benefits.map((item, i) => <div key={i} className="flex items-start" data-id="element-169">
                <div className="bg-accent-blue/20 p-1 rounded-full mr-3 mt-1" data-id="element-170">
                  <Check className="w-4 h-4 text-accent-blue" data-id="element-171" />
                </div>
                <p className="text-text-secondary" data-id="element-172">{item}</p>
              </div>)}
          </div>
        </div>

        <div className="order-1 md:order-2 relative" data-id="element-173">
          <div className="absolute inset-0 bg-accent-blue/20 blur-3xl rounded-full" data-id="element-174" />
          <img src="https://cdn.magicpatterns.com/uploads/3gkMifQBZ6VSxPwtSxsRSr/heylloyd-image-1770531244690.png" alt="Embudo Exprés Product" className="relative z-10 w-full rounded-xl shadow-2xl border border-white/10 rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-175" />
        </div>
      </div>
    </Section>;
}